import * as api from '@utils/api'
import React, { ReactElement, useState } from 'react'
import useAllActions from '@hooks/use-all-actions'
import { Button, InputBase } from '@mui/material'
import { UserType } from '@types'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  input: {
    marginLeft: theme.spacing(1),
    flex: 2,
    border: `1px solid #d5d5d5`,
  },
  output: {
    border: '1px solid gray',
  },
}))

interface Props {
  user: UserType
}

const PasswordResetLink = ({ user }: Props): ReactElement => {
  const { setFlashMessage } = useAllActions()
  const { classes } = useStyles()
  const [email, setEmail] = useState('')
  const [submitDisabled, setSubmitDisabled] = useState(false)
  useState(false)
  const [result, setResult] = useState('')

  const createPasswordResetLink = async (id, email) => {
    const { data: response } = await api.POST(
      `/p4/users/${id}/createPasswordResetLink`,
      {
        email: email,
      },
    )
    return response
  }

  const submit = async () => {
    setSubmitDisabled(true)

    try {
      const results = await createPasswordResetLink(user.id, email)
      setResult(results)
      setFlashMessage('Password reset link generated', 'success')
    } catch (e: any) {
      setFlashMessage(e.message, 'error')
      setResult(`Unable to generate password reset link: ${e.message}`)
    }

    setEmail('')
    setSubmitDisabled(false)
  }

  return (
    <div>
      <p>
        Please be assured by the customer that they are the real user before
        sharing a password reset link. Please verify they are using the linked
        email to communicate or ask for recent transaction details for example.
      </p>
      <div>
        <label>Confirm email</label>
        <InputBase
          className={classes.input}
          disabled={submitDisabled}
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />
        <Button disabled={submitDisabled} onClick={submit}>
          Generate Password Reset Link
        </Button>
      </div>
      <div>
        <pre className={classes.output}>
          {result ? JSON.stringify(result, null, '\t') : null}
        </pre>
      </div>
    </div>
  )
}

export default PasswordResetLink
